import { ProductItemModel } from '../../data-layer/posts/types';
import { PostSource, PostStatus } from '../../ui/posts/constants';
import { ReactionState, type PostPersistenceUI, type PostUI } from '../../ui/posts/types';
import { pluralize } from '../../utils/pluralize';
import type { BusinessUI } from '../../ui/business/types';

export const buildPreviewModel = (
    persistenceUI: PostPersistenceUI,
    businessUI: BusinessUI,
    products: ProductItemModel[],
): PostUI => ({
    id: 'preview',
    url: '#',
    shareUrl: '#',
    views: 0,
    likes: 0,
    saved: false,
    reactionState: ReactionState.NONE,
    business: businessUI,
    text: persistenceUI.text,
    source: PostSource.MANUAL,
    clickouts: persistenceUI.site
        ? [
              {
                  url: persistenceUI.site,
                  target: 'button',
                  text: 'На сайт',
              },
          ]
        : [],
    createdAt: new Date().toISOString(),
    status: PostStatus.DRAFT,
    content: persistenceUI.media.map((media) => ({
        id: media.id,
        type: media.type,
        media: [
            media.type === 'video'
                ? {
                      width: media.width,
                      height: media.height,
                      firstFrameUrl: media.firstFrameUrl,
                      url: media.url,
                  }
                : {
                      width: media.width,
                      height: media.height,
                      url: media.url,
                  },
        ],
    })),
    products: {
        items: products,
        title: 'Товары из образа',
        buttonTitle: products.length > 1 ? 'Товары' : 'Товар',
        businessButtonTitle: 'Еще товары',
        description:
            products.length > 1
                ? `${products.length} ${pluralize(products.length, 'Товар', 'Товара', 'Товаров')}`
                : '',
    },
    tags: [],
});
